
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.2 3.6a1.2 1.2 0 10-2.4 0v1.2a1.2 1.2 0 002.4 0V3.6zM18.788 6.909a1.2 1.2 0 00-1.697-1.697l-.848.848a1.2 1.2 0 001.697 1.697l.848-.848zM21.6 12a1.2 1.2 0 01-1.2 1.2h-1.2a1.2 1.2 0 010-2.4h1.2a1.2 1.2 0 011.2 1.2zM6.06 7.757A1.2 1.2 0 007.757 6.06l-.848-.848a1.2 1.2 0 00-1.697 1.697l.848.848zM6 12a1.2 1.2 0 01-1.2 1.2H3.6a1.2 1.2 0 010-2.4h1.2A1.2 1.2 0 016 12zM9.6 19.2V18h4.8v1.2a2.4 2.4 0 11-4.8 0zM14.401 16.8c.018-.409.248-.776.571-1.03a4.8 4.8 0 10-5.944 0c.323.254.553.622.57 1.03h4.803z","fill":"#fff"}})])
          )
        }
      }
    